require('./parent.js')
require('./scripts/rtl2player.jquery.js')


// WEBPACK FOOTER //
// ./src/embed.legacy.js